(function( $ ) {
    $.fn.select2Build = function()
    {
        let $el  = $(this);
        if($el.attr('data-not2')==null || $el.attr('data-not2')=='' || typeof $el.attr('data-not2')=='undefined')
        {
            let obj = {placeholder: 'กรุณาเลือก', allowClear: true};
            let url = $el.attr('data-ajax--url');
            let clear = $el.attr('data-clear');
            if (typeof clear !== 'undefined') {
                obj['allowClear'] = false;
            }
            if (typeof url != 'undefined') {
                obj['ajax'] = {
                    url: url,
                    dataType: 'json',
                    delay: 250,
                    data: function (params) {
                        return {
                            q: params.term,
                            page: params.page,
                        };
                    },
                    processResults: function (data, params) {
                        params.page = params.page || 1;
                        return {
                            results: data.items,
                            pagination: {
                                more: (params.page * 25) < data.total_count
                            }
                        };
                    },
                    cache: true
                }
            }
            else {
                if ($el.children().length < 10) {
                    obj['minimumResultsForSearch'] = 'Infinity';
                }
            }
            $el.select2(obj);
            if (typeof url != 'undefined') {
                $el.on("select2:select", function (e) {
                    var data = e.params.data;
                    var name = $(e.currentTarget).attr('name');
                    var is_hidden = $(e.currentTarget).attr('data-hidden');
                    if (typeof name !== 'undefined' && name != null && is_hidden != 'hidden') {
                        if (name.match(/\[/)) {
                            var names = name.split('[');
                            if (names.length == 2) {
                                $('#' + names[0] + '_text[' + names[1]).remove();
                                $("<input type='hidden' id='" + names[0] + "_text[" + names[1] + "' name='" + names[0] + "_text[" + names[1] + "'>").val(data.text).insertAfter($(e.currentTarget));
                            }
                        }
                        else {
                            $('#' + name + "_text").remove();
                            $("<input type='hidden' id='" + name + "_text' name='" + name + "_text'>").val(data.text).insertAfter($(e.currentTarget));
                        }
                    }
                });
            }
        }
    };
}( jQuery ));
$.fn.select2.defaults.set("width", "100%");
$('select').each(function(i,e){
    if($(e).attr('data-not2')==null || $(e).attr('data-not2')=='' || typeof $(e).attr('data-not2')=='undefined')
    {
        $(e).select2Build();
    }
});
